import { GridColTypeDef } from "@mui/x-data-grid";

const baseColumn: GridColTypeDef = {
  width: 125
}

export default baseColumn;